<template>
  <div class="help" @click="$emit('close')">
    <template v-if="!reqing">
      <div class="help-redpacket opened" v-if="isOpen" @click.stop>
        <div class="help-redpacket-money">{{help_price}}元</div>
        <div class="help-redpacket-text opened" :class="{hasRedpacket: is_new_rp}">
          恭喜您！帮好友拆了{{help_price}}元
          <div v-show="is_new_rp">
            并获得一个
            <span>{{rp_price}}</span> 助力红包
          </div>
        </div>
        <div class="help-redpacket-logo"></div>
        <div class="help-redpacket-tips" v-html="helpTipsText"></div>
        <a class="help-btn activate" @click="activate" href="#" v-if="is_new_rp">立即激活</a>
        <a class="help-btn activate" @click="check" href="#" v-else>立即查看</a>
      </div>
      <div class="help-redpacket" v-else-if="isFail">
        <div class="help-redpacket-text fail" v-html="errText"></div>
        <div class="help-btn open" @click="$emit('close')">我知道了</div>
      </div>
      <div class="help-redpacket" v-else @click.stop>
        <div class="help-redpacket-text phone">请填写手机助力帮拆</div>
        <input
          @blur="blur"
          @focus="focus"
          class="help-redpacket-phone"
          type="tel"
          placeholder="输入手机号码，助力拆红包"
          v-model="phone"
          maxlength="11"
        >
        <input
          @blur="blur"
          @focus="focus"
          class="help-redpacket-code img"
          type="text"
          placeholder="输入图形验证码"
          v-model="imgCode"
          maxlength="4"
        >
        <img class="help-redpacket-img" :src="`${captcha}?t=${t}`" @click="changeImg">
        <input
          @blur="blur"
          @focus="focus"
          class="help-redpacket-code text"
          type="tel"
          placeholder="输入短信验证码"
          v-model="phoneCode"
          maxlength="6"
        >
        <div class="help-redpacket-btn" @click="getCode">
          获取验证码
          <span v-if="codeBtnIng">{{time}}s</span>
        </div>
        <div class="form-err" v-if="formErr">{{formErr}}</div>
        <div class="help-btn open" @click="helpOpen">立即帮拆</div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '@/api/api';

let isProd = process.env.NODE_ENV === 'production';
export default {
  name: 'help',
  data() {
    return {
      formErr: '',
      reqing: true,
      isFail: false,
      isShow: false,
      isOpen: false,
      hasRedpacket: true,
      codeImgUrl: '',
      t: 1,
      imgCode: '',
      phoneCode: '',
      phone: '',
      help_price: '',
      rp_price: 0,
      is_new_rp: true,
      errText: '',
      codeBtnIng: false,
      helpBtnIng: false,
      time: 60,
      appUrl: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.icbc.elife&android_schema=com.icbc.elife%3A%2F%2Felife%2Floading%3FactID%3DHD0460190111252&ios_schema=com.icbc.elife%3A%2F%2Felife%3FactID%3DHD0460190111252',
      captcha: isProd
        ? 'https://new.h5no1.com/icbc-get-lucky/api/h5/business/captcha'
        : '/icbc-get-lucky/api/h5/business/captcha'
    };
  },
  props: {
    hasPhone: Boolean
  },
  computed: {
    ...mapGetters(['rp_id']),
    helpTipsText() {
      return this.is_new_rp
        ? '前往工银e生活激活，还可以领最高2019元大礼！'
        : '前往工银e生活查看您的红包，<br>还可领最高2019元大礼！';
    }
  },
  destroyed() {
    clearInterval(this.phoneCodeTime);
  },
  mounted() {
    if (this.hasPhone) {
      api
        .postWxHelp({
          rp_id: this.$route.query.rpId,
          phone: '',
          code: ''
        })
        .then(res => {
          console.log(res);
          this.isOpen = true;
          this.help_price = res.result.help_price;
          this.rp_price = res.result.rp_price;
          this.is_new_rp = res.result.is_new_rp;
          this.reqing = false;
          this.$emit('isHelp');
        })
        .catch(err => {
          console.log(err);
          window.Sentry && window.Sentry.captureException(err);
          this.reqing = false;
          this.showFail(err);
        });
    } else {
      this.reqing = false;
    }
  },
  methods: {
    check(e) {
      e.preventDefault();
      fiboSDK.btnClick('wx-check-btn', 'wx立即查看');
      setTimeout(() => {
        window.location.href = this.appUrl;
      }, 200);
    },
    activate(e) {
      e.preventDefault();
      fiboSDK.btnClick('wx-activate-btn', 'wx立即激活');
      setTimeout(() => {
        window.location.href = this.appUrl;
      }, 200);
    },
    blur() {
      this.hasFocus = false;
      setTimeout(() => {
        if (!this.hasFocus) {
          window.scrollTo(0, 0);
        }
      }, 100);
    },

    focus() {
      this.hasFocus = true;
    },

    getCode() {
      if (this.codeBtnIng) {
        return;
      }
      this.formErr = '';
      if (!this.phone || !/^1\d{10}$/.test(this.phone)) {
        this.formErr = '手机号码有误';
        return;
      }
      if (!this.imgCode || !/^[\da-z]{4}$/i.test(this.imgCode)) {
        this.formErr = '图形验证码有误';
        return;
      }
      this.codeBtnIng = true;
      api
        .getWxPhoneCode({
          phone: this.phone,
          pic_code: this.imgCode
        })
        .then(() => {
          this.phoneCodeTime = setInterval(() => {
            if (this.time <= 0) {
              clearInterval(this.phoneCodeTime);
              this.codeBtnIng = false;
              this.time = 60;
              return;
            }
            this.time -= 1;
          }, 1000);
        })
        .catch(err => {
          this.codeBtnIng = false;
          window.Sentry && window.Sentry.captureException(err);
          if (err.error_code === -1109) {
            this.formErr = '请稍等重新获取验证码';
            return;
          }
          this.formErr = err.msg || err.message;
        });
    },
    helpOpen() {
      if (this.helpBtnIng) {
        return;
      }
      this.formErr = '';
      if (!this.phone || !/^1\d{10}$/.test(this.phone)) {
        this.formErr = '手机号码有误';
        return;
      }
      if (!this.imgCode || !/^[\da-z]{4}$/i.test(this.imgCode)) {
        this.formErr = '图形验证码有误';
        return;
      }
      if (!this.phoneCode || !/^\d{6}$/.test(this.phoneCode)) {
        this.formErr = '手机验证码有误';
        return;
      }
      this.helpBtnIng = true;
      try {
        fiboSDK.btnClick('wx-help-btn', 'wx立即帮拆');
      } catch (e) {
        window.Sentry && window.Sentry.captureException(e);
      }
      api
        .postWxHelp({
          rp_id: this.$route.query.rpId,
          phone: this.phone,
          code: this.phoneCode
        })
        .then(res => {
          console.log(res);
          if (res.ok) {
            this.help_price = res.result.help_price;
            this.rp_price = res.result.rp_price;
            this.is_new_rp = res.result.is_new_rp;
            this.isOpen = true;
            this.helpBtnIng = false;
            this.$emit('isHelp');
          }
        })
        .catch(err => {
          console.log(err);
          if (err.error_code != -1104 || err.error_code != -1107) {
            window.Sentry && window.Sentry.captureException(new Error(err.message));
          }
          this.showFail(err);
          this.helpBtnIng = false;
        });
    },
    changeImg() {
      this.t += 1;
    },
    closeHelp() {
      this.isShow = false;
    },
    showFail(err) {
      if (err.error_code === -1107) {
        this.errText = '助力失败<br>不能自己给自己助力的~';
        this.isFail = true;
      } else if (err.error_code === -1105) {
        this.errText = '助力失败<br>活动期间只能给<br>同一好友助力10次';
        this.isFail = true;
      } else if (err.error_code === -1104) {
        this.errText = '助力失败<br>您今天已经<br>给3个好友助力过';
        this.isFail = true;
      } else {
        // alert(err.message);
        this.formErr = err.msg || err.message;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/index.scss';
.form-err {
  position: absolute;
  bottom: 3.5%;
  left: 0;
  width: 100%;
  text-align: center;
  color: white;
  @include set-property(font-size, 24);
}

.help {
  @include set-image('../assets/images/mask.png');
  background-size: 100% 100%;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  input {
    border-radius: 6px;
    border: none;
    padding: 4px;
    text-align: center;
    @include set-property(font-size, 22.6);
  }
  &-redpacket {
    @include set-image('../assets/images/help-redpacket.png');
    @include set-size(457, 613);
    position: relative;
    &-text {
      color: #ffffff;
      &.phone {
        @include set-lt(86, 240);
        @include set-property(font-size, 31.8);
      }
      &.opened {
        @include set-size(380, 0);
        @include set-lt(38, 368);
        @include set-property(font-size, 28.3);
        &.hasRedpacket {
          @include set-lt(38, 340);
          span {
            @include set-property(font-size, 31.8);
            color: #fdd875;
          }
        }
      }
      &.fail {
        @include set-size(457, 0);
        @include set-lt(0, 240);
        @include set-property(line-height, 60);
        text-align: center;
      }
    }
    &-phone {
      @include set-size(380, 58);
      @include set-lt(40, 337);
    }
    &-code {
      @include set-size(190, 58);
      &.img {
        @include set-lt(40, 410);
      }
      &.text {
        @include set-lt(40, 485);
      }
    }
    &-img {
      @include set-size(173, 58);
      @include set-lt(246, 410);
    }
    &-btn {
      @include set-size(167, 58);
      @include set-lt(246, 485);
      @include set-property(font-size, 22.6);
      @include set-property(line-height, 58);
      border-radius: 6px;
      color: #2a0201;
      background-color: #f8d57a;
    }
    &.opened {
      @include set-image('../assets/images/help-redpacket-opened.png');
      @include set-size(457, 713);
    }
    &-money {
      @include set-lt(168, 107);
      @include set-property(font-size, 44);
      color: #800118;
    }
    &-logo {
      @include set-image('../assets/images/help-redpacket-logo.png');
      @include set-size(97, 97);
      @include set-lt(175, 450);
    }
    &-tips {
      position: absolute;
      width: 78%;
      right: 0;
      left: 0;
      margin: auto;
      @include set-property(top, 580);
      @include set-property(font-size, 24);
      color: #fbd97c;
    }
  }
  &-btn {
    @include set-image('../assets/images/home-redpacket-btn.png');
    @include set-size(236, 55);
    @include set-property(font-size, 31);
    @include set-property(line-height, 55);
    color: #81010a;
    &.open {
      @include set-lt(100, 660);
    }
    &.activate {
      @include set-lt(110, 760);
    }
  }
}
</style>
